<template>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 480 8">
    <path
      d="M392,0l8,8h-16l8-8ZM400,8h16l-8-8-8,8ZM368,8h16l-8-8-8,8ZM352,8h16l-8-8-8,8ZM472,0l-8,8h16l-8-8ZM416,8h16l-8-8-8,8ZM448,8h16l-8-8-8,8ZM432,8h16l-8-8-8,8ZM256,8h16l-8-8-8,8ZM272,8h16l-8-8-8,8ZM240,8h16l-8-8-8,8ZM224,8h16l-8-8-8,8ZM320,8h16l-8-8-8,8ZM336,8h16l-8-8-8,8ZM304,8h16l-8-8-8,8ZM288,8h16l-8-8-8,8ZM128,8h16l-8-8-8,8ZM112,8h16L120,0l-8,8ZM96,8h16L104,0l-8,8ZM144,8h16l-8-8-8,8ZM208,8h16l-8-8-8,8ZM192,8h16l-8-8-8,8ZM160,8h16l-8-8-8,8ZM176,8h16l-8-8-8,8ZM16,8h16L24,0l-8,8ZM0,8h16L8,0,0,8ZM32,8h16L40,0l-8,8ZM80,8h16L88,0l-8,8ZM48,8h16L56,0l-8,8ZM64,8h16L72,0l-8,8Z"
    />
  </svg>
</template>
